// extracted by mini-css-extract-plugin
export default {"wrapper":"_e527332b","dimensions":"_8e90f9b"};